module.exports = "{{amount}}\n"


//////////////////
// WEBPACK FOOTER
// /srv/projects/jsapp/src/app/shared/currency-current/currency-current.component.html
// module id = ZEmZ
// module chunks = 6